module.exports = __webpack_public_path__ + "media/images/icons/cv-353c5fbc934661cf3e94b38e54917d91.svg";